<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>System Notification</h5>

  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    (click)="onClose()"
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<form #f="ngForm" (ngSubmit)="onSubmit(f)">

  <hr class="m-0 p-0">

  <mat-dialog-content class="px-3 py-4">

    <div class="alert alert-warning mb-4" role="alert">
      <b>Identifier:</b> {{ system_notification.identifier }}
      <ng-container *ngIf="system_notification.is_site_related">
        <br>
        <i>
          This system notification is {{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site').toLowerCase() }} related.
        </i>
      </ng-container>
    </div>

    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Label</mat-label>
      <input
        matInput
        placeholder="Label"
        [(ngModel)]="system_notification.label"
        name="label"
        type="text"
        id="label"
        required />
      <mat-hint>Enter the label of the system notification.</mat-hint>
    </mat-form-field>

    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Description</mat-label>
      <textarea
        matInput
        rows="3"
        placeholder="Description"
        [(ngModel)]="system_notification.description"
        name="description"
        type="text"
        id="description"
        required>
      </textarea>
      <mat-hint>Enter the description of the system notification.</mat-hint>
    </mat-form-field>

    <mat-form-field class="full-width mb-0" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Feature</mat-label>
      <input
        matInput
        placeholder="Feature"
        [(ngModel)]="system_notification.feature"
        name="feature"
        type="text"
        id="feature"
        required />
      <mat-hint>Enter the feature of the system notification.</mat-hint>
    </mat-form-field>

  </mat-dialog-content>

  <hr class="m-0 p-0">

  <mat-dialog-actions class="d-flex justify-content-end px-3 py-1">
    <button
      mat-raised-button
      [disabled]="!f.valid"
      type="submit"
      class="my-2 ml-1 mr-2"
      color="primary">
      <mat-icon>save</mat-icon> Update
    </button>

    <button
      mat-raised-button
      [disabled]="!f.valid"
      type="button"
      class="my-2 mx-1"
      color="primary"
      (click)="onSubmit(f, true)">
      <mat-icon>save</mat-icon> Update & Close
    </button>
  </mat-dialog-actions>
</form>
